module.exports = __webpack_public_path__ + "img/dark-changelog-preview.0e3abc7f.png";